<template>
    <div>
        <div class="previewImage" id="imageFull">
            <div @click="previewFunctions('imageHide')" id="imageHide" class="imageHide"></div>
            <div class="lg-toolbar lg-group">
                <el-tooltip class="item" effect="dark" content="Close" placement="bottom">
                    <span class="lg-close lg-icon icon icon-close" @click="previewFunctions('imageHide')" id="imageHide"></span>
                </el-tooltip>
                <span v-if="!filePreview.content_type.startsWith('image/svg+xml')">
                    <el-tooltip class="item" effect="dark" content="Download" placement="bottom">
                        <a class="lg-download lg-icon icon icon-download" href="javascript:;" @click="previewFunctions('downloadFile')" id="downloadFile"></a>
                    </el-tooltip>
                    <span v-if="isFullScreen == false" @click="previewFunctions('imageFullScreen')" id="imageFullScreen" v-show="filePreview.content_type.startsWith('image')  || filePreview.content_type.startsWith('application/octet-stream') || filePreview.content_type.startsWith('audio') || filePreview.content_type.startsWith('video')">
                        <el-tooltip class="item" effect="dark" content="Full Screen" placement="bottom">
                            <span class="lg-fullscreen lg-icon icon icon-fullscreen"></span>
                        </el-tooltip>
                    </span>
                    <span v-else @click="previewFunctions('exitFullScreen')" id="exitFullScreen" v-show="filePreview.content_type.startsWith('image')  || filePreview.content_type.startsWith('application/octet-stream') || filePreview.content_type.startsWith('audio') || filePreview.content_type.startsWith('video')">
                        <el-tooltip class="item" effect="dark" content="Full Screen" placement="bottom">
                            <span class="lg-fullscreen lg-icon icon icon-fullscreen-exit"></span>
                        </el-tooltip>
                    </span>
                    <el-tooltip class="item" effect="dark" content="Rotate Left" placement="bottom">
                        <span id="rotateLeft" class="lg-icon icon icon-rotate-left" @click="previewFunctions('rotateLeft')" v-if="filePreview.content_type.startsWith('image') || filePreview.content_type.startsWith('application/octet-stream')"></span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Rotate Right" placement="bottom">
                        <span id="rotateRight" class="lg-icon icon icon-rotate-right" @click="previewFunctions('rotateRight')" v-if="filePreview.content_type.startsWith('image') || filePreview.content_type.startsWith('application/octet-stream')"></span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Zoom Out" placement="bottom">
                        <span id="zoomOut" class="lg-icon icon icon-magnify-minus-outline zoomOut" v-if="(filePreview.content_type.startsWith('image') || filePreview.content_type.startsWith('application/octet-stream')) && scale == 1"></span>
                        <span id="zoomOut" class="lg-icon icon icon-magnify-minus-outline" @click="previewFunctions('zoomOut')" v-if="(filePreview.content_type.startsWith('image') || filePreview.content_type.startsWith('application/octet-stream')) && scale>1"></span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Zoom In" placement="bottom">
                        <span id="zoomIn" class="lg-icon icon icon-magnify-plus-outline" @click="previewFunctions('zoomIn')" v-if="filePreview.content_type.startsWith('image') || filePreview.content_type.startsWith('application/octet-stream')"></span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Zoom Reset" placement="bottom">
                        <span id="zoomReset" class="lg-icon icon icon-image-filter-none" style="font-size: 18px !important;line-height: 36px;" @click="previewFunctions('zoomReset')" v-if="filePreview.content_type.startsWith('image') || filePreview.content_type.startsWith('application/octet-stream')"></span>
                    </el-tooltip>
                </span>
                <div>
                    <span class="font-weight-bold m-4 text-white d-flex" style="font-size:17px;align-items:center">{{filePreview.name}}</span>
                    <!-- <span class="previewLogo">
                        <router-link class="navbar-branddigi" :to="{'name': 'Home'}">
                            <span class="navlogo mr-1">
                                <i class="logo-cloud font-weight-bold text-white" style="font-size: 18px;"></i>
                            </span>
                            <span class="dark-logo hidden-sm-down font-weight-bold text-white">
                                DigiCloud
                            </span>
                        </router-link>
                    </span>     -->
                </div>
            </div>
            <div class="image-wrapper" v-if="loadMedia == true">
                <hollow-dots-spinner
                :animation-duration="1000"
                :dot-size="17"
                :dots-num="3"
                color="#fff"/>
            </div>
            <!-- <div class="image-wrapper" @click.prevent="handleClick()" @click="previewFunctions('zoomIn')" :style="imgTransform" :class="{transition: imgTransitionStatus}" v-else-if="filePreview.content_type.startsWith('application/octet-stream')">
                <img :src="filePreview.url" class="imageDisplay" accept="*">
            </div> -->
            <!-- <div class="image-wrapper" v-else-if="filePreview.content_type.startsWith('text') || filePreview.content_type.startsWith('application') || filePreview.content_type.startsWith('video/x-flv') || filePreview.content_type.startsWith('image/svg+xml')"> -->
            <div class="image-wrapper" v-else-if="filePreview.content_type.startsWith('text') || filePreview.content_type.startsWith('application') || filePreview.content_type.startsWith('video/x-flv')">
                <div class="text-white noPreview">
                    No Preview for this file
                    <!-- <div class="d-block mt-3" @click="previewFunctions('downloadFile',filePreview['_id']['$oid'])" id="downloadFile">
                        <button type="button" class="btn btn-secondary btn-smm" style="box-shadow: none;">Download</button>
                    </div> -->
                </div>
            </div>
            <div class="image-wrapper" @click.prevent="handleClick()" @click="previewFunctions('zoomIn')" :style="imgTransform" :class="{transition: imgTransitionStatus}" v-else-if="filePreview.content_type.startsWith('image')">
                <img :src="filePreview.url" class="imageDisplay" accept="*">
            </div>
            <div class="image-wrapper" v-else-if="filePreview.content_type.startsWith('video')">
                <video width="920" height="520" controls autoplay poster="/static/images/video-icon.svg" controlsList="nodownload" disablepictureinpicture class="mt-5">
                    <source :src="filePreview.url" type="">
                </video>
            </div>
            <div class="image-wrapper" v-else-if="filePreview.content_type.startsWith('audio')">
                <img src="https://cdn.digicollect.com/cdn/dccloud/static/images/images-new-theme/cloud/audio-icon.svg" class="ml-12" style="width:20rem;">
                <audio controls controlsList="nodownload" class="mt-4 d-block" autoplay>
                    <source :src="filePreview.url" type="">
                </audio>
            </div>
            <!-- <div class="image-wrapper" @click="zoomIn()" v-else-if="filePreview.content_type.startsWith('application/pdf')" style="width:500px">
                <object :data="this.image_url" width="400" height="400" type='application/pdf'>
                    <embed :src="this.image_url" type='application/pdf'></embed>
                </object>
            </div>     -->
        </div>
    </div>
</template>
<script>
import { EventBus } from "./eventBus/nav-bar-event.js";
import {HollowDotsSpinner} from 'epic-spinners'
export default {
    props:['filePreview'],
    data() {
        return{
            image_url:'',
            scale:1,
            rotateImage: 0,
            imgIndex: 0,
            imgTransitionStatus: true,
            top: 0,
            left: 0,
            lastX: 0,
            lastY: 0,
            loadMedia: false,
            isFullScreen: false,
            hideFunctions: false
        }
    },
    methods: {
        previewFunctions(obj){
            if(obj == 'zoomReset'){
                this.scale = 1
            }
            else if(obj == 'zoomIn'){
                this.scale += 0.25
            }
            else if(obj == 'zoomOut'){
                if (this.scale !== 0) {
                    this.scale -= 0.25
                }
            }
            else if(obj == 'rotateRight'){
                this.scale = 1
                this.rotateImage += 90
            }
            else if(obj == 'rotateLeft'){
                this.scale = 1
                this.rotateImage -= 90
            }
            else if(obj == 'imageFullScreen'){
                this.isFullScreen = true;
                var imgFull = document.getElementById("imageFull");
                if (imgFull.requestFullscreen) {
                    imgFull.requestFullscreen();
                }
                else if (imgFull.msRequestFullscreen) {
                    imgFull.msRequestFullscreen();
                }
                else if (imgFull.mozRequestFullScreen) {
                    imgFull.mozRequestFullScreen();
                }
                else if (imgFull.webkitRequestFullscreen) {
                    imgFull.webkitRequestFullscreen();
                } else {
                    console.log("Fullscreen API is not supported");
                }
            }
            else if(obj == 'exitFullScreen'){
                this.isFullScreen = false;
                var imgFull = document.getElementById("imageFull");
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            }
            else if(obj == 'downloadFile'){
                // this.$http.post('download_file', {'_id':this.fileId,'account_id':this.accId})
                // .then(response => {
                    this.download_url = this.image_url
                    var a = document.createElement('A');
                    a.href = this.download_url;
                    a.download = 'abc';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                // })
            }
            else if(obj == 'imageHide'){
                this.isFullScreen = false;
                EventBus.$emit('hide image');
            }
        },
        handleClick(e){

        }
    },
    mounted() {
        this.loadMedia = true;
        // this.$http.post('download_file', {'_id':this.fileId, 'account_id':this.accId})
        // .then(response => {
            this.image_url = this.filePreview.url
            this.loadMedia = false;
        // });
    },
    computed: {
        imgTransform: {
            get () {
                return {
                    transform: `translate(-50%, -50%)
                    scale(${this.scale})
                    rotate(${this.rotateImage}deg)`,
                }
            }
        }
    },
    components: {
        HollowDotsSpinner,
    },
}
</script>

<style>
.closeImage{
    z-index: 9998;
    position: fixed;
    top: 35px;
    right: 36px;
    cursor: pointer;
}
.closeImage i{
    font-size: 42px;
}
.previewImage{
    z-index: 9998;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.70);
    opacity: 1;
    transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;
}
.image-wrapper{
    transform: translate(-50%, -50%) scale(1) rotate(-0deg);
    top: calc(50% + 0px);
    left: calc(50% + 0px);
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50% -50%);
    transform: translate(-50% -50%);
    transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;
}
.imageDisplay{
    vertical-align: middle;
    position: relative;
    background: #ffff;
    max-width: 80vw;
    max-height: 60vh;
    cursor: move;
}
.img-wrapper.transition {
    transition: transform 0.3s ease-in-out;
}
.imageFunctions{
    user-select: none;
    position: fixed;
    bottom: 30px;
    z-index: 99999;
    left: 50%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
}
.imageFunctions span{
    background: rgba(45,45,44,.8);
    border-radius: 50%;
    margin-right: 6px;
    padding: 4px;
}
.imageFunctions i{
    font-size: 25px;
}
.noPreview{
    background-color: #4c494c;
    -webkit-border-radius: 12px;
    border-radius: 12px;
    color: #fff;
    cursor:auto !important;
    margin-bottom: 40px;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: center;
    -webkit-box-shadow: 0 10px 12px 5px rgba(0,0,0,0.2) !important;
    box-shadow: 0 10px 12px 5px rgb;
    font-weight: bold;
}
.lg-toolbar{
    z-index: 1082;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0,0,0,.75);
}
.lg-toolbar .lg-icon{
    color: #fff;
    cursor: pointer;
    float: right;
    font-size: 24px;
    height: 57px;
    line-height: 37px;
    padding: 10px 0;
    text-align: center;
    width: 50px;
    text-decoration: none !important;
    outline: medium none;
    -webkit-transition: color 0.2s linear;
    -o-transition: color 0.2s linear;
    transition: color 0.2s linear;
}
.imageHide{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.zoomOut{
    opacity: 0.6;
}
.previewLogo{
    position: absolute;
    left: 46%;
    display: flex;
    font-size: 20px;
    margin-top: 14px;
}
video {
    background-repeat: no-repeat;
    background-size: 30px 10px;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewCallAttacthment.vue